"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _RowDetailsSelect = _interopRequireDefault(require("./RowDetailsSelect"));
var _RowDetailsInput = _interopRequireDefault(require("./RowDetailsInput"));
var _ListRowsAreas = _interopRequireDefault(require("./ListRowsAreas"));
var _vuex = require("vuex");
var _constants = require("@/config/constants");
var _lodash = _interopRequireDefault(require("lodash"));
var _ButtonQRCode = _interopRequireDefault(require("./ButtonQRCode"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default2 = exports.default = {
  name: 'ListSuplotsAreas',
  components: {
    RowDetailsSelect: _RowDetailsSelect.default,
    RowDetailsInput: _RowDetailsInput.default,
    ListRowsAreas: _ListRowsAreas.default,
    ButtonQRCode: _ButtonQRCode.default
  },
  props: {
    subPlots: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    getSubPlots: {
      type: Function,
      default: function _default() {}
    },
    plot: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    openModalEdit: {
      type: Function,
      default: function _default() {}
    }
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    isLoading: 'isLoading',
    userAdmin: 'userAdmin'
  })), {}, {
    checkPermission: function checkPermission() {
      return _constants.LIST_ADMINS.includes(this.userAdmin.role);
    }
  }),
  data: function data() {
    return {
      isOpen: false,
      subPlotsData: [],
      errorInput: null,
      products: null,
      technics: null,
      arrayUpdatesArea: [],
      arrayUpdatesCode: [],
      arrayDeleteGroup: []
    };
  },
  mounted: function mounted() {
    this.subPlotsData = this.setRePlaceValuesArea(_lodash.default.cloneDeep(this.subPlots));
  },
  watch: {
    subPlots: function subPlots(val) {
      var subPlot = this.subPlotsData.find(function (item) {
        return item.isOpen;
      });
      this.subPlotsData = this.setRePlaceValuesArea(val);
      if (subPlot) {
        this.subPlotsData.find(function (item) {
          if (item.id === subPlot.id) item.isOpen = true;
        });
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['deleteSubPlot', 'updateSubPlot', 'fetchProducts', 'listServiceTechnics'])), {}, {
    verifyOpen: function verifyOpen(idx) {
      return this.subPlotsData[idx].isOpen;
    },
    setRePlaceValuesArea: function setRePlaceValuesArea(arr) {
      var _this = this;
      return _lodash.default.forEach(arr, function (item) {
        if (item.area) {
          item.area = _this.$options.filters.convertAreaNoUnit(item.area);
        }
      });
    },
    toggleCollapse: function () {
      var _toggleCollapse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(item, index) {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              data = _lodash.default.cloneDeep(this.subPlotsData);
              data.find(function (item) {
                if (item.id !== data[index].id) item.isOpen = false;else item.isOpen = !item.isOpen;
              });
              if (!data[index].isOpen) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return this.getProducts();
            case 1:
              this.$set(this, 'subPlotsData', data);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function toggleCollapse(_x, _x2) {
        return _toggleCollapse.apply(this, arguments);
      }
      return toggleCollapse;
    }(),
    getProducts: function () {
      var _getProducts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.fetchProducts();
            case 1:
              this.products = _context2.v;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getProducts() {
        return _getProducts.apply(this, arguments);
      }
      return getProducts;
    }(),
    showMsg: function showMsg(msg, type) {
      this.$buefy.toast.open({
        duration: 5000,
        message: msg || "Opera\xE7\xE3o realizada com sucesso",
        type: type || 'is-success'
      });
    },
    confirmDeleteRow: function confirmDeleteRow() {
      var _this2 = this;
      this.$buefy.dialog.confirm({
        title: this.$t('pages.productive_areas.detail.alerts.delete_alert_title'),
        message: this.$t('pages.productive_areas.detail.alerts.delete_alert_message'),
        confirmText: 'Excluir',
        cancelText: 'Cancelar',
        type: 'is-danger',
        onConfirm: function onConfirm() {
          return _this2.deleteSubPlotRest();
        }
      });
    },
    deleteSubPlotRest: function () {
      var _deleteSubPlotRest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.deleteSubPlot(this.arrayDeleteGroup);
            case 1:
              res = _context3.v;
              if (res) {
                this.arrayDeleteGroup = [];
                this.$emit('getSubPlots');
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function deleteSubPlotRest() {
        return _deleteSubPlotRest.apply(this, arguments);
      }
      return deleteSubPlotRest;
    }(),
    validAreaPlot: function validAreaPlot(value) {
      var total = 0;
      this.subPlotsData.map(function (subPlot) {
        total += Number(subPlot.area);
      });
      return Number(total.toFixed(2)) >= (Number(this.$options.filters.convertAreaNoUnit(this.plot.area)) || 0);
    },
    // eslint-disable-trailing-spaces
    verifyUpdateCode: function verifyUpdateCode(e) {
      var value = Number(e.target.value);
      var count = 0;
      for (var index = 0; index < this.subPlotsData.length; index++) {
        var ele = this.subPlotsData[index];
        if (Number(ele.code) === value) count++;
      }
      var id = e.target.id;
      var idItem = id.split('_')[3];
      var data = this.subPlots.find(function (s) {
        return Number(s.id) === Number(idItem);
      });
      var valueOld = Number(data.code);
      if (valueOld !== value) {
        this.arrayUpdatesCode.push(idItem);
      } else {
        this.arrayUpdatesCode = this.arrayUpdatesCode.filter(function (s) {
          return s !== idItem;
        });
      }
      return count === 0;
    },
    updateCodes: function updateCodes(e) {
      var _this3 = this;
      e.preventDefault();
      if (!this.verifyUpdateCode(e)) {
        return this.$buefy.dialog.alert({
          title: this.$t('errors.title'),
          message: this.$t('errors.area_code_duplicity'),
          type: 'is-danger',
          confirmText: 'OK',
          onConfirm: function onConfirm() {
            return _this3.resetValue(e);
          }
        });
      }
      this.$buefy.dialog.confirm({
        title: this.$t('errors.title'),
        message: this.$t('errors.area_update_code'),
        type: 'is-danger',
        cancelText: 'Cancelar',
        confirmText: 'OK',
        onConfirm: function onConfirm() {
          return _this3.updateSubPlotRest(e);
        },
        onCancel: function onCancel() {
          return _this3.resetValue(e);
        }
      });
    },
    // eslint-disable-trailing-spaces
    verifyUpdateArea: function verifyUpdateArea(e) {
      var id = e.target.id;
      var idItem = Number(id.split('_')[0]);
      var data = this.subPlotsData.find(function (s) {
        return Number(s.id) === idItem;
      });
      var valueOld = Number(data.area);
      var valueNew = Number(e.target.value);
      // if (e.target && e.type !== 'blur') return valueOld !== valueNew

      this.subPlotsData = this.subPlotsData.map(function (sub) {
        return Number(sub.id) === Number(data.id) ? _objectSpread(_objectSpread({}, sub), {}, {
          area: String(valueNew)
        }) : sub;
      });
      var newValueConvert = valueNew / 0.00010000;
      if (valueOld !== newValueConvert && valueOld !== valueNew) {
        this.arrayUpdatesArea.push(idItem);
      }
      if (Number(e.target.value).toFixed(2) === e.target.value) {
        this.errorInput = e.target.name;
      }
      var elementRef = this.$refs["".concat(idItem, "_area_ref")][0];
      if (elementRef) {
        var valid = elementRef.checkHtml5Validity();
        if (!valid) this.errorInput = e.target.name;else this.errorInput = undefined;
      }
      if (this.errorInput) {
        return false;
      } else {
        return true;
      }
    },
    updateAreaAlert: function updateAreaAlert(e) {
      var _this4 = this;
      if (this.verifyUpdateArea(e)) {
        e.preventDefault();
        this.$buefy.dialog.confirm({
          title: this.$t('pages.productive_areas.detail.alerts.title'),
          message: this.$t('pages.productive_areas.detail.alerts.update_area'),
          type: 'is-danger',
          cancelText: 'Não',
          confirmText: 'Sim',
          onConfirm: function onConfirm() {
            return _this4.updateSubPlotRest(e);
          },
          onCancel: function onCancel() {
            return _this4.resetValueArea(e);
          }
        });
      }
    },
    resetValueArea: function resetValueArea(e) {
      var id = e.target.id;
      var idItem = id.split('_')[0];
      var data = this.subPlots.find(function (item) {
        return item.id === idItem;
      });
      var value = data.area;
      document.getElementById(id).value = Number(value);
      this.arrayUpdatesArea = [];
    },
    resetValue: function resetValue(e) {
      var id = e.target.id;
      var value = id.split('_')[0];
      document.getElementById(id).value = Number(value);
      var idItem = id.split('_')[3];
      this.arrayUpdatesCode = this.arrayUpdatesCode.filter(function (s) {
        return s !== idItem;
      });
    },
    updateSubPlotRest: function () {
      var _updateSubPlotRest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
        var key, idSubPlot, value, payload, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              key = e.target.name.split('_')[1];
              idSubPlot = e.target.name.split('_')[0];
              value = e.target.value;
              if (value) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!((key === 'code' || key === 'area') && !(!isNaN(parseFloat(value)) && isFinite(value)))) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, this.showMsg('Valor fora do padrão', 'is-danger'));
            case 2:
              if (!(key === 'area')) {
                _context4.n = 3;
                break;
              }
              if (!this.validAreaPlot(value)) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2, this.showMsg('Valor utrapassa o tamanho máximo de hectares do Talhão', 'is-danger'));
            case 3:
              if (!(key === 'productId')) {
                _context4.n = 5;
                break;
              }
              _context4.n = 4;
              return this.listServiceTechnics(value);
            case 4:
              this.technics = _context4.v;
            case 5:
              payload = {
                idSubPlot: idSubPlot,
                data: {}
              };
              payload.data[key] = value;
              if (key === 'area') payload.data[key] = value / 0.00010000;
              this.arrayUpdatesArea = [];
              this.arrayUpdatesCode = [];
              _context4.n = 6;
              return this.updateSubPlot(payload);
            case 6:
              res = _context4.v;
              if (res) {
                this.errorInput = null;
                this.$emit('getSubPlots');
              } else {
                this.errorInput = e.target.name;
              }
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function updateSubPlotRest(_x3) {
        return _updateSubPlotRest.apply(this, arguments);
      }
      return updateSubPlotRest;
    }(),
    editItem: function editItem(item) {
      this.$emit('openModalEdit', _objectSpread(_objectSpread({}, item), {}, {
        typeItem: _constants.SUBPLOT
      }));
    }
  })
};